export const TimeIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.625 0.625C5.68794 0.625 0.875 5.43794 0.875 11.375C0.875 17.3121 5.68794 22.125 11.625 22.125C17.5621 22.125 22.375 17.3121 22.375 11.375C22.375 5.43794 17.5621 0.625 11.625 0.625ZM15.418 6.16785L11.6251 9.9607L9.33218 7.66785L7.91797 9.08206L10.2109 11.375L9.41797 12.1678L10.8322 13.5821L11.6251 12.7892L12.418 13.5821L13.8322 12.1678L13.0393 11.375L16.8322 7.58206L15.418 6.16785Z"
      fill="#2BB747"
    />
  </svg>
);
